import React from "react";
import { Dimensions, Platform, StyleSheet, View } from "react-native";
import { StepperTypeTokens, } from "@voltmoney/schema";
import { SCREEN_SIZE } from '@voltmoney/types';
import CustomHeader from "../../customHeader/CustomHeader";
import Stepper from "../../stepper/Stepper";
const TrackForeClosure = ({ height, apiData, goBackAction, needHelpAction, triggerAction, stepperData }) => {
    const _headerChild = () => {
        return (React.createElement(CustomHeader, { id: "header_trackForeclosure_header", title: "Track closure request", goBackAction: goBackAction, needHelpAction: needHelpAction, triggerAction: triggerAction }));
    };
    // @ts-ignore
    return (React.createElement(View, { style: [
            styles.container,
            { height: height - 17 }
        ] },
        React.createElement(View, { style: Platform.OS === "ios" ? {} : { height: 54, ...Platform.OS === "web" && { paddingHorizontal: -16, marginTop: Platform.OS === "web" && -16 } } }, _headerChild()),
        React.createElement(View, { style: { padding: 16, backgroundColor: "#F3F5FC", height: height - 51 } },
            React.createElement(View, { style: { borderRadius: 12, paddingLeft: 16, paddingRight: 16, paddingTop: 16, backgroundColor: 'white' } },
                React.createElement(Stepper, { type: StepperTypeTokens.VERTICAL, data: stepperData, isProcessing: true })))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
// @ts-ignore
const styles = StyleSheet.create({
    container: {
        marginLeft: -16,
        marginRight: -16,
    },
});
export default (TrackForeClosure);
